import React, { lazy, Suspense } from 'react';
import { Helmet } from 'react-helmet-async';
import NavBar from '@/components/NavBar';
import MainFooter from '@/components/MainFooter';
import HeroSection from './startup-offering/HeroSection';
import FounderLetter from './startup-offering/FounderLetter';
import ProductVideo from './startup-offering/ProductVideo';
import PricingSection from './startup-offering/PricingSection';
import ShoppinTestimonial from './startup-offering/ShoppinTestimonial';
import FAQ from '@/components/FAQ';
import FinalCTA from './startup-offering/FinalCTA';

const TripleAdvantage = lazy(() => import('@/components/TripleAdvantage'));

const LoadingFallback = () => (
  <div className="flex justify-center items-center py-12">
    <div className="animate-pulse h-8 w-full max-w-md bg-gray-100 rounded-lg"></div>
  </div>
);

const StartupOffering = () => {
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Startup Support Plan - Cutshort</title>
        <meta name="description" content="Scale your startup team with Cutshort's engineering talent offering." />
      </Helmet>
      <NavBar />
      <main>
        <HeroSection />
        <FounderLetter />
        
        <Suspense fallback={<LoadingFallback />}>
          <TripleAdvantage />
        </Suspense>

        <ProductVideo />

        <PricingSection />

        <ShoppinTestimonial />

        <FAQ tags={["startup-offering", "general"]} title="Frequently Asked Questions" subtitle="Everything you need to know about the Startup Support Plan" />

        <FinalCTA />

        {/* Other sections will be added here section by section as requested */}
      </main>
      <MainFooter />
    </div>
  );
};

export default StartupOffering;
